import React, { useEffect, useRef, useState } from 'react';
import Lottie from 'lottie-react';

export default function LottieIconButton({
  animationData,
  onClick,
  className,
  playerClassName,
  label,
}) {
  const lottieRef = useRef(null);
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = (event) => setReduceMotion(event.matches);
    setReduceMotion(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  const play = () => {
    if (reduceMotion) return;
    lottieRef.current?.goToAndPlay(0, true);
  };

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      onMouseEnter={play}
      onFocus={play}
      aria-label={label}
      title={label}
    >
      {animationData ? (
        <span className={playerClassName}>
          <Lottie
            lottieRef={lottieRef}
            animationData={animationData}
            loop={!reduceMotion}
            autoplay={!reduceMotion}
            renderer="svg"
            rendererSettings={{ preserveAspectRatio: 'xMidYMid meet' }}
            style={{ width: '100%', height: '100%' }}
          />
        </span>
      ) : null}
    </button>
  );
}
